<div class="h-full flex flex-col" *ngIf="traceability">
  <dx-data-grid
    [glamResource]="traceability"
    class="flex-1 overflow-auto"
    [remoteOperations]="{ paging: true, filtering: true, sorting: true }"
    [scrolling]="scrolling"
    [paging]="paging"
    height="1"
  >
    <dxi-column
      dataField="date"
      dataType="datetime"
      [format]="'dd/MM/yyyy HH:mm:ss'"
      [sortOrder]="'desc'"
      [sortIndex]="0"
      [caption]="'common.date' | translate | ucfirst">
    </dxi-column>
    <dxi-column
      dataField="documentTypeName"
      [caption]="'entity.documentType.documentType' | translate | ucfirst"
      />
    <dxi-column
      dataField="documentName"
      [caption]="'entity.document.number' | translate | ucfirst"
      />
    <dxi-column
      dataField="locationCode"
      [caption]="'entity.container.containerLocation' | translate | ucfirst"
      />
    <dxi-column
      dataField="containerCode"
      [caption]="'entity.container.containerId' | translate | ucfirst"
      />
    <dxi-column
      dataField="inventoryReconciliationValue" dataType="number"
      [caption]="'entity.container.inventoryReconciliationValue' | translate | ucfirst"
      />
    <dxi-column
      dataField="quantityIn" dataType="number"
      [caption]="'entity.container.quantityIn' | translate | ucfirst"
      />
    <dxi-column
      dataField="quantityOut" dataType="number"
      [caption]="'entity.container.quantityOut' | translate | ucfirst"
      />
    <dxi-column
      dataField="formatName"
      [caption]="'entity.productFormat.formatId' | translate | ucfirst"
      />
  </dx-data-grid>
</div>

<dx-load-panel *ngIf="!traceability"
  [visible]="true"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
/>
